import { Getter } from "vuex";
import { IState } from "./state";

const title: Getter<IState, IState> = (state) => state.title;
const searchResult: Getter<IState, IState> = (state) => state.searchResult;
const items: Getter<IState, IState> = (state) => state.searchResult.items;
const totalItems: Getter<IState, IState> = (state) =>
  state.searchResult.totalItems;
const currentPage: Getter<IState, IState> = (state) => state.currentPage;
const hitsPerPage: Getter<IState, IState> = (state) => state.hitsPerPage;
const amountShowing: Getter<IState, IState> = (state) =>
  state.searchResult.showingHits;

export default {
  title,
  searchResult,
  items,
  totalItems,
  currentPage,
  hitsPerPage,
  amountShowing,
};
